import angular from 'angular';
import { ArrowBoxModule } from '../common/directives/arrow-box';
import { MatchMediaModule } from '../common/directives/match-media/match-media.module';
import { AppHeaderComponent } from './app-header.component';
import { CompanyLogoComponent } from './company-logo';
import { ProfessionalLogoComponent } from './professional-logo';
import { MoverDropdownComponent } from './mover-dropdown';

export const AppHeaderModule = angular
  .module('app.header', [ArrowBoxModule.name, MatchMediaModule.name])
  .component('updAppHeader', AppHeaderComponent)
  .component('updCompanyLogo', CompanyLogoComponent)
  .component('updProfessionalLogo', ProfessionalLogoComponent)
  .component('updMoverDropdown', MoverDropdownComponent);
